import { pregnancyData } from '../lib/data';
import styles from './Pregnancy.module.scss';

const Pregnancy = () => {
    return ( 
        <section >
            <div className = {styles.container}> 
                {pregnancyData.map(({id, photo}) => (
                    <div className = {styles.container__photo} key={id}> 
                    <img  className={styles.photo} src={photo} alt="беременность фото Ставрополь"/>
                    </div>
                ))}                
            </div>
        </section>
    );
}
export default Pregnancy;